<template>
  <div class="c-top">
    <News />
    <TopCsvKeiyaku />
    <TopCsvSchedule />
    <TopEventList />
    <TopCsvLottery />
    <MainMenu />
    <TopBanner />
    <div class="c-top__adminMenuWrap">
      <AdminMenu :permissions="currentUser.permissions" />
    </div>
  </div>
</template>

<script>
import News from "@/components/News.vue";
import MainMenu from "@/components/MainMenu.vue";
import AdminMenu from "@/components/AdminMenu.vue";
import TopEventList from "@/components/TopEventList.vue";
import TopCsvKeiyaku from "@/components/TopCsvKeiyaku.vue";
import TopCsvSchedule from "@/components/TopCsvSchedule.vue";
import TopCsvLottery from "@/components/TopCsvLottery.vue";
import TopBanner from "@/components/TopBanner.vue";
// import MeetingSummary from "@/components/MeetingSummary.vue";
export default {
  data() {
    return {
      bannerData: [],
    };
  },
  components: {
    News,
    MainMenu,
    AdminMenu,
    TopEventList,
    TopCsvKeiyaku,
    TopCsvSchedule,
    TopCsvLottery,
    TopBanner,
  },
  async mounted() {
    console.log("++++ mc top");
    await this.$nextTick();
    window.initH2();
    if (window.menuInit) {
      window.menuInit();
    }
  },
  computed: {},
};
</script>

<style></style>
